import * as React from "react";
import { ConfirmDialog } from "security-app/components/common/Modal";
import { useModalContext } from "common/contexts";
import { useUpdateSecurityEvent } from "security-app/hooks/useSecurityEventsAPI";
import { SECURITY_EVENT_STATUSES } from "security-app/hooks/api/securityEventsAPI.types";
import useSendEventActionTelemetry from "components/events/events/hooks/useSendEventActionTelemetry";
function ConfirmStatusChange() {
  const {
    entity: { securityEvent, newStatus, onCancelCB },
    setEntity,
    setModal
  } = useModalContext();
  const { updateSecurityEvent, updatingSecurityEvent } = useUpdateSecurityEvent();
  const sendEventActionTelemetry = useSendEventActionTelemetry();
  const onConfirm = async () => {
    const payload = {
      owner: securityEvent.owner,
      notes: securityEvent.notes,
      status: newStatus
    };
    await updateSecurityEvent({ id: securityEvent.event_id, data: payload });
    sendEventActionTelemetry("SET_STATUS", false);
    setModal(null);
    setEntity(null);
  };
  const onCancel = () => {
    onCancelCB == null ? void 0 : onCancelCB();
    setModal(null);
    setEntity(null);
  };
  return /* @__PURE__ */ React.createElement(
    ConfirmDialog,
    {
      show: true,
      onConfirm,
      confirmDisabled: updatingSecurityEvent,
      isLoading: updatingSecurityEvent,
      confirmText: "Confirm",
      onCancel,
      title: "Change Event Status"
    },
    /* @__PURE__ */ React.createElement("p", null, "Are you sure you want to change the status to ", /* @__PURE__ */ React.createElement("b", null, SECURITY_EVENT_STATUSES[newStatus], "?"))
  );
}
export default ConfirmStatusChange;
